<template>
  <v-card
    style="width: 100% !important; height: 100% !important; overflow: hidden"
  >
    <v-toolbar dense flat style="background: transparent">
      <v-toolbar-title>{{ module.title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text align="center">{{
      getDescription + (targetName === null ? "N/A" : targetName)
    }}</v-card-text>
    <v-card-actions align="center">
      <v-btn
        class="mb-5"
        style="margin: 0 auto"
        color="primary"
        @click="buttonClick()"
      >
        {{ $t("common.run") }}
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("common.run") }}</span>
        </v-card-title>
        <v-card-text>
          {{ $t("common.verify") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            {{ $t("common.no") }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="submit()">
            {{ $t("common.yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Meta from "@/_helpers/ModuleMeta";

export default {
  name: "ModFunctionButton",

  mixins: [Meta],

  data() {
    return {
      targetId: null,
      targetName: "",
      functionType: null,
      dialog: false,
    };
  },

  props: ["module"],

  methods: {
    ...mapActions("scripts", { getScript: "getScript", runScript: "execute" }),
    ...mapActions("dashboards", ["getDashboard"]),

    async buttonClick() {
      if (this.functionType == Meta.Enum.DASHBOARDID) {
        this.$router.push("/dashboard/" + this.targetId);
        this.$router.go();
      } else this.dialog = true;
    },

    async submit() {
      this.dialog = false;
      if (this.module.meta == undefined) return;
      await this.runScript({ scriptId: this.targetId });
    },

    async checkType() {
      if (this.module.meta == undefined) return;

      let script = await this.getMeta(this.module.meta, Meta.Enum.SCRIPTID);

      if (script) {
        this.functionType = Meta.Enum.SCRIPTID;
        this.targetId = script.value;

        await this.getScript({ scriptId: script.value });
        this.targetName = this.currentScript.name;
        return;
      }

      let dashboard = await this.getMeta(
        this.module.meta,
        Meta.Enum.DASHBOARDID
      );

      if (dashboard) {
        this.functionType = Meta.Enum.DASHBOARDID;
        this.targetId = dashboard.value;

        await this.getDashboard({ dashboardId: dashboard.value });
        this.targetName = this.currentDashboard.name;
      }
    },
  },
  computed: {
    ...mapState("scripts", ["currentScript"]),
    ...mapState("dashboards", ["currentDashboard"]),

    getDescription() {
      if (this.functionType == Meta.Enum.DASHBOARDID) return "Dashboard: ";
      else if (this.functionType == Meta.Enum.SCRIPTID) return "Script: ";

      return "";
    },
  },

  async mounted() {
    await this.checkType();
  },
};
</script>

<style></style>
